module.exports = __webpack_public_path__ + "f7a377dcd4a41fdb939289b6e7026920.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/welcome-images/images/welcome-diamond-pattern-right@2x.png
// module id = 801
// module chunks = 0